import { DestroyRef, Directive, inject, input, OnInit, signal, TemplateRef, ViewContainerRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { map } from 'rxjs';
import { MediaObserverService } from '../media-observer.service';
import { MediaBreakpoints } from '../consts';

@Directive({
  selector: '[libMediaShowDown]',
})
export class MediaShowDownDirective implements OnInit {
  breakpoint = input.required<keyof MediaBreakpoints>({ alias: 'libMediaShowDown' });

  includeEquals = input<boolean>(true, {
    alias: 'libMediaShowDownIncludeEquals',
  });

  protected hasView = signal<boolean>(false);

  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly viewContainer = inject(ViewContainerRef);
  private readonly mediaObserver = inject(MediaObserverService);
  private readonly destroy = inject(DestroyRef);

  ngOnInit(): void {
    this.mediaObserver.breakpoint$
      .pipe(
        map(breakpoint => this.mediaObserver.isBreakpointDown(breakpoint, this.breakpoint(), this.includeEquals())),
        takeUntilDestroyed(this.destroy)
      )
      .subscribe(shouldShow => {
        if (shouldShow && !this.hasView()) {
          this.viewContainer.createEmbeddedView(this.templateRef);
          this.hasView.set(true);
        } else if (!shouldShow && this.hasView) {
          this.viewContainer.clear();
          this.hasView.set(false);
        }
      });
  }
}
